import { Paper, List, TextField } from "@mui/material";
import React, { useState, useMemo } from "react";
import Asset from "datalign-module-template/models/asset";
import FileMenu from "./file-menu/FileMenu";

export default function FilesList({ assets }: { assets: Asset[] }) {
  const [search, setSearch] = useState("");

  const filteredAssets = useMemo(() => {
    if (!search) return assets;
    return assets.filter((asset) =>
      asset.name.toLowerCase().includes(search.toLowerCase()),
    );
  }, [search, assets]);

  return (
    <Paper elevation={3} sx={{ p: 2 }}>
      <TextField
        fullWidth
        size="small"
        variant="outlined"
        placeholder="Search files..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        sx={{ mb: 1 }}
      />

      <List
        sx={{
          width: "100%",
          overflow: "auto",
          maxHeight: 300,
        }}
        disablePadding
      >
        {filteredAssets.map((asset, index) => (
          <FileMenu
            asset={asset}
            last={filteredAssets.length - 1 === index}
            key={`file-${asset.guid}`}
          />
        ))}
      </List>
    </Paper>
  );
}
